<template>
  <section class="cv-card" aria-labelledby="cvcard-title">
    <div class="cv-ribbon">
      <div class="cv-ribbon__text">
        本日 <strong>{{ nowLabel }}</strong><br>今なら最短でご案内可能！
      </div>
    </div>

    <div class="cv-arrow">▼</div>

    <div class="cv-trust">
      <div class="cv-trust__card">
        <h3 class="cv-trust__title under-yellow" id="cvcard-title">{{ vendorName }}</h3>

        <div class="cv-trust__logo-wrap">
          <img class="cv-trust__logo" src="../../assets/rank-table/vendor-1.png" :alt="vendorName" />
        </div>

        <div class="cv-trust__content">
          <ul class="cv-trust__bullets">
            <li class="cv-trust__bullet"><span class="check">✔</span><span class="bold-red">最短30分で駆けつけ！</span></li>
            <li class="cv-trust__bullet"><span class="check">✔</span>業界最安値級！<span class="bold-red">最大91%OFF！</span></li>
            <li class="cv-trust__bullet"><span class="check">✔</span>工事・商品の<span class="bold-red">10年無料保証</span></li>
            <li class="cv-trust__bullet"><span class="check">✔</span>Google口コミ<span class="bold-red">4.8！</span></li>
            <li class="cv-trust__bullet"><span class="check">✔</span>お客様満足度<span class="bold-red">97.3%！</span></li>
          </ul>
        </div>
        <!-- <img src="../../assets/cv/hikaku.png" alt="" class="hikaku"> -->
      </div>
    </div>

    <div class="cv-review" aria-label="ご利用者の声">
      <p class="cv-review__title">＼実際にご利用いただいたお客様の声／</p>

      <div class="cv-review__cards" role="list">
        <article v-for="(r, i) in visibleReviews" :key="'vis-' + i" class="cv-review__card" role="listitem">
          <div class="cv-review__head">
            <img class="cv-review__icon" src="../../assets/google-review.png" alt="">
            <span class="cv-review__stars" :aria-label="r.aria">{{ r.stars }}</span>
          </div>

          <p class="cv-review__text" v-html="r.text"></p>
          <p class="kutikom">※ 引用元：Google口コミ</p>
          <div class="cv-review__meta"></div>
        </article>
      </div>

      <transition name="cv-accord">
        <div v-show="showMore" class="cv-review__more-wrap">
          <div class="cv-review__cards" role="list">
            <article v-for="(r, i) in hiddenReviews" :key="'hid-' + i" class="cv-review__card" role="listitem">
              <div class="cv-review__head">
                <img class="cv-review__icon" src="../../assets/google-review.png" alt="">
                <span class="cv-review__stars" :aria-label="r.aria">{{ r.stars }}</span>
              </div>

              <p class="cv-review__text" v-html="r.text"></p>
              <p class="kutikom">※ 引用元：Google口コミ</p>
              <div class="cv-review__meta"></div>
            </article>
          </div>
        </div>
      </transition>

      <p class="cv-review__note">※ 個人の感想であり、対応時間は地域・状況により異なります。</p>

      <div v-if="hiddenCount > 0" class="cv-review__more-cta">
        <button type="button" class="cv-review__more-btn" :aria-expanded="showMore ? 'true' : 'false'"
          @click="toggleMore">
          <span v-if="!showMore">口コミをもっと見る（+{{ hiddenCount }}件）</span>
          <span v-else>閉じる</span>
        </button>
      </div>
    </div>

    <div class="cv-precta-band" role="note" aria-label="ご案内">
      <p class="nowLabel">本日<strong>{{ nowLabel }}</strong>時点<br>
        <span class="bold-red">今なら空きがあり最短でご案内可能！</span>
      </p>
      <img src="../../assets/table-1.png" alt="">

      <template v-if="timeBand === 'day'">
        <div class="notice-text-box">
          <p class="notice-text">
            12月〜2月は給湯器の故障が特に多く、相談や見積もり依頼が集中するため、
            <span class="bold-red">当日や翌日の対応が難しくなるケースが増えます。</span><br>
          </p>
          <p class="notice-text">ただし、今ならまだ空きがあり、最短でのご案内が可能。</p>
          <p class="notice-text">
            もちろん、見積もり後に金額や内容に納得できなければ、
            <span class="bold-red">そのままキャンセルOK！</span>
          </p>
          <!-- <p class="notice-text">
          <strong>「まだどこの業者にするか悩んでる...」<br>
            「失敗したくないから慎重に選びたい…」</strong>
        </p> -->
          <p class="notice-text">
            空きがある今のうちにサクッと確認しておくことをおすすめします。
          </p>
        </div>
      </template>
    </div>

    <div class="limited-down-label" aria-hidden="true">
      <span>期間限定キャンペーン実施中!</span>
    </div>

    <a :href="affiliateLink" class="campaign-banner" target="_blank" rel="nofollow noopener"
      aria-label="施工完了でAmazonギフト券3,000円プレゼントの詳細（新しいタブで開く）">
      <img src="../../assets/amazon-banner2025.jpg" alt="施工完了でAmazonギフト券3,000円プレゼント（期間限定）" width="700" height="278"
        loading="lazy">
    </a>

    <p class="campaign-caution">
      ※こちらのキャンペーンはいつ終了するかわかりません。
    </p>

    <div class="cv-microcopy" aria-hidden="true">
      <span class="chip bold-font">＼業界最安値級・最短で今日お湯が使える！／</span>
    </div>

    <div class="cv-bottom-cta">
      <a class="btn btn-primary pulse-btn" :href="affiliateLink" target="_blank" rel="nofollow noopener"
        aria-label="まずは無料相談してみる（新しいタブで開く）">
        今なら空きあり！<br>まずは無料見積もりを申し込む
      </a>
      <p class="cta-note">※ キャンセル料無料・しつこい営業一切なし</p>
    </div>
  </section>
</template>

<script>
import { makeAffiliateUrl } from '../../utils/aff.js';

export default {
  name: "CVBoostCard",
  props: {
    vendorName: { type: String, default: "給湯器駆けつけ隊" },
    vendorLogo: { type: String, required: true },
    personImg: { type: String, required: true },
    now: { type: Date, default: () => new Date() },
  },
  data() {
    return {
      nowInternal: this.now,
      timerId: null,
      showMore: false,
      reviews: [
        {
          text: "<strong class='under-yellow'>当日に連絡し、当日に施工いただきました。</strong><br><br>価格も見積りを数件行ったなかで<strong class='under-yellow'>1番安かった</strong>です。<br><br>施工担当の方も丁寧で手際が良く短時間で終わりました。またお願いしたいと思います。",
          stars: "★★★★★",
        },
        {
          text: "いきなり夜に給湯器故障で翌日朝にweb検索で連絡、当日夕方には来訪いただき交換。<br><br>電話連絡での見積説明も適切、当日交換対応いただいたスタッフの方も迅速に対応いただき<strong class='under-yellow'>故障から20時間で風呂に入れた事に家族で感動しました！</strong><br><br>ありがとうございました‼",
          stars: "★★★★★",
        },
        {
          text: "電話対応から迅速で、機器の選択、工事も丁寧かつ説明も分かりやすく、<strong class='under-yellow'>電話連絡から半日も経たないうちに、給湯器が新しくなりました。</strong><br><br>しかも<strong class='under-yellow'>どこよりも安くて本当に助かりました。</strong><br><br>雨のなかの作業、本当にありがとうございました。",
          stars: "★★★★★",
        },
        {
          text: "給湯器交換を依頼したした<strong>その日に駆けつけて、交換してもらえました。</strong><br><br>価格も、<strong class='under-yellow'>電話で見積もってもらった時の価格から上がることはなく、</strong>しかも、何社から見積りを取りましたが、一番リーズナブルでした。",
          stars: "★★★★★",
        },
        {
          text: "給湯器の故障でいろいろなところで見積もってもらいましたが、そこちらは金額も安く何より次の日に来てもらえるとの事でほんと助かりました。<br><br><strong class='under-yellow'>他はどんなに早くても4〜5日かかると言われました。</strong>",
          stars: "★★★★★",
        }
      ],
    };
  },
  computed: {
    nowLabel() {
      const d = this.nowInternal;
      const m = d.getMonth() + 1;
      const day = d.getDate();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      return `${m}月${day}日${hh}時${mm}分`;
    },
    visibleReviews() {
      return this.reviews.slice(0, 2);
    },
    hiddenReviews() {
      return this.reviews.slice(2);
    },
    hiddenCount() {
      return Math.max(this.reviews.length - 2, 0);
    },
    affiliateLink() {
      return makeAffiliateUrl();
    },
    timeBand() {
      const h = this.nowInternal.getHours();
      if (h >= 5 && h < 19) return 'day';
      if (h >= 19 || h < 5) return 'day';
      return 'day';
    }
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore;
    },
  },
  mounted() {
    this.timerId = setInterval(() => {
      this.nowInternal = new Date();
    }, 1000);
  },
  beforeUnmount() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
/* ============== base ============== */
.cv-card {
  --bg: #f9f6da;
  --paper: #ffffff;
  --text: #223042;
  --muted: #667085;
  --border: rgba(34, 48, 66, .12);
  --accent: #d9534f;
  --accent-dark: #c84844;
  --warn: #ff7a00;

  background: var(--bg);
  max-width: 920px;
  margin: 0 auto;
  border-radius: 16px;
  padding: 12px 12px 0;
  box-shadow: 0 12px 28px rgba(0, 0, 0, .06);
  overflow: hidden;
}

.notice-text-box {
  background: #f2f2f2;
  padding: 15px;
  border-radius: 10px;
}

.bold-red {
  color: #d32f2f;
  font-weight: 800;
}

.hikaku {
  width: 90%;
  margin: 0 auto;
}

.under-yellow {
  display: inline;
  background: linear-gradient(transparent 62%, rgba(255, 205, 63, .6) 62%);
  padding: 0 .06em;
}

.bold-font {
  font-weight: 900;
}

/* ============== ribbon ============== */
.cv-ribbon {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: linear-gradient(180deg, #e4635f 0%, var(--accent) 60%, var(--accent-dark) 100%);
  padding: 18px 16px;
  color: #fff;
  font-weight: 900;
  line-height: 1.35;
  border-radius: 14px;
  margin: 10px 8px 0;
}

.cv-ribbon__text {
  font-size: 1.05rem;
  letter-spacing: .02em;
}

.cv-ribbon__text strong {
  color: #ffe6a1;
  font-weight: 1000;
  text-decoration: none;
  padding: 0 .25em;
  border-radius: 8px;
  background: rgba(0, 0, 0, .16);
}

/* ============== arrow ============== */
.cv-arrow {
  text-align: center;
  font-size: 3rem;
  color: var(--accent);
  font-weight: 900;
  margin: -6px 0 8px;
  line-height: 1;
  animation: arrowFloat 1.8s ease-in-out infinite;
}

@keyframes arrowFloat {

  0%,
  100% {
    transform: translateY(0);
    opacity: .95;
  }

  50% {
    transform: translateY(4px);
    opacity: 1;
  }
}

/* ============== trust card ============== */
.cv-trust {
  padding: 0 10px 6px;
}

.cv-trust__card {
  background: var(--paper);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px 14px;
}

.cv-trust__title {
  margin: 0 0 10px;
  font-size: clamp(18px, 3.2vw, 22px);
  line-height: 1.25;
  color: var(--text);
  font-weight: 1000;
  letter-spacing: .01em;
  position: relative;
  padding-bottom: 8px;
}

.cv-trust__logo-wrap {
  text-align: center;
  margin: 10px 0 6px;
}

.cv-trust__logo {
  width: min(280px, 86%);
  height: auto;
  display: inline-block;
}

.cv-trust__content {
  margin-top: 10px;
}

.cv-trust__bullets {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
  color: var(--text);
  font-weight: 700;
  font-size: 0.8rem;
}

.cv-trust__bullet {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.5;
  background: rgba(34, 48, 66, .03);
  border: 1px solid rgba(34, 48, 66, .08);
  border-radius: 12px;
  padding: 8px 9px;
}

.check {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: rgba(46, 204, 113, .18);
  color: #18a957;
  font-weight: 1000;
  margin-top: 1px;
}

/* ============== review ============== */
.cv-review {
  margin: 10px auto 14px;
  max-width: 820px;
  padding: 0 12px;
}

.cv-review__title {
  font-weight: 1000;
  font-size: 1rem;
  color: var(--text);
  margin: 6px 0 10px;
  text-align: center;

  /* background: rgba(255,255,255,.7); */
  /* border: 1px solid var(--border); */
  border-radius: 999px;
  padding: 8px 12px;
  margin-bottom: 0;
  padding-bottom: 0;
}

.cv-review__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  text-align: left;
}

.cv-review__card {
  background: var(--paper);
  border: 1px solid rgba(230, 225, 200, .9);
  border-radius: 14px;
  padding: 12px 14px 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .04);
}

.cv-review__head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cv-review__icon {
  width: 28px;
  height: auto;
  display: inline-flex;
}

.cv-review__stars {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  letter-spacing: .08em;
  font-weight: 1000;
  color: #ffc107;
  padding: 2px 0;
}

.cv-review__text {
  margin: 10px 0 0;
  font-size: .85rem;
  line-height: 1.7;
  color: #2b2b2b;
}

.kutikom {
  text-align: right;
  font-size: .7rem;
  color: #777;
  margin: 10px 0 0;
}

.cv-review__note {
  margin: 8px 2px 0;
  font-size: .72rem;
  color: #777;
  text-align: left;
}

.cv-review__more-cta {
  text-align: center;
  margin-top: 10px;
}

.cv-review__more-btn {
  appearance: none;
  border: 1px solid var(--border);
  background: #fff;
  padding: 10px 16px;
  border-radius: 999px;
  font-weight: 900;
  font-size: .95rem;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .05);
  transition: transform .08s ease, box-shadow .2s ease;
}

.cv-review__more-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, .08);
}

/* accord */
.cv-accord-enter-active,
.cv-accord-leave-active {
  transition: opacity .22s ease, transform .22s ease;
}

.cv-accord-enter-from,
.cv-accord-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ============== pre-cta band (SP only) ============== */
.cv-precta-band {
  display: none;
  background: #fff;
}

@media (max-width:480px) {
  .cv-precta-band {
    display: block;
    margin: 12px 12px 14px;
    padding: 12px 12px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 14px;
    text-align: left;
  }

  .nowLabel {
    text-align: center;
    font-size: 1rem;
    /* font-weight: 1000; */
    color: var(--text);
    margin: 0 0 8px;
  }

  .nowLabel strong {
    text-align: center;
    font-size: 1.2rem;
    /* font-weight: 1000; */
    color: var(--text);
    margin: 0 0 8px;
  }

  .nowLabel span {
    font-size: 1.12rem;
  }

  .cv-precta-band img {
    width: 50%;
    max-width: 360px;
    margin: 8px auto 10px;
    display: block;
    border-radius: 10px;
  }

  .notice-text {
    margin: 0 0 8px;
    color: #3a3a3a;
    line-height: 1.65;
    font-size: .85rem;
  }
}

/* ============== campaign ============== */
.limited-down-label {
  display: flex;
  justify-content: center;
  margin: 22px auto 8px;
}

.limited-down-label>span {
  display: inline-block;
  background: #e53935;
  color: #fff;
  font-weight: 1000;
  font-size: 0.8rem;
  letter-spacing: .02em;
  padding: 8px 18px;
  position: relative;
  border-radius: 999px;
  box-shadow: 0 10px 20px rgba(229, 57, 53, .18);
}

.limited-down-label>span::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #e53935;
}

.campaign-banner {
  display: block;
  margin: 14px auto 6px;
  max-width: 820px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 22px rgba(0, 0, 0, .10);
  transition: transform .08s ease, box-shadow .2s ease;
}

.campaign-banner:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, .14);
}

.campaign-banner img {
  display: block;
  width: 100%;
  height: auto;
}

.campaign-caution {
  margin: 6px auto 18px;
  font-size: .85rem;
  text-align: left;
  color: #666;
  line-height: 1.5;
  padding-bottom: 0;
}

/* ============== microcopy + CTA ============== */
.cv-microcopy {
  display: flex;
  justify-content: center;
  padding: 2px 10px 8px;
}

.cv-microcopy .chip {
  font-size: .85rem;
  font-weight: 900;
  color: rgb(216, 87, 87);
  border-radius: 999px;
  padding: 8px 14px;
  padding-bottom: 0;
  margin-bottom: 0;
}

.cv-bottom-cta {
  text-align: center;
  padding: 0 0 28px;
}

.cta-note {
  margin-top: 6px;
  color: #6b7280;
  font-size: .9rem;
}

/* button */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 12px 18px;
  font-weight: 900;
}

.btn a{
  font-size: 0.8rem;
}

.btn-primary {
  --btn-bg: #ff7a00;
  --btn-bg-dark: #e96e00;
  --btn-grad-top: #ffa043;
  --btn-shadow: 0 12px 26px rgba(233, 110, 0, .28);
  --btn-radius: 999px;
  color: #fff;
  background: linear-gradient(180deg, var(--btn-grad-top) 0%, var(--btn-bg) 45%, var(--btn-bg) 100%);
  border: 2px solid var(--btn-bg-dark);
  border-radius: var(--btn-radius);
  box-shadow: var(--btn-shadow);
  width: 85%;
  box-sizing: border-box;
  padding: 18px 24px;
  font-size: 1rem;
  letter-spacing: .02em;
  line-height: 1.15;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  transition: transform .08s ease, box-shadow .2s ease, filter .2s ease;
}

.btn-primary::before {
  content: "";
  position: absolute;
  top: 0;
  left: -80px;
  width: 60px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .55) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-20deg);
  animation: shine 4s infinite;
  pointer-events: none;
}

@keyframes shine {
  0% {
    left: -80px;
  }

  60% {
    left: 115%;
  }

  100% {
    left: 115%;
  }
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(233, 110, 0, .32);
  filter: brightness(1.02);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 10px 18px rgba(233, 110, 0, .22);
}

.btn-primary:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(255, 122, 0, .9), var(--btn-shadow);
}

/* pulse */
.pulse-btn {
  animation: pulse 1.6s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.04);
  }

  100% {
    transform: scale(1);
  }
}

@media (prefers-color-scheme: dark) {
  .btn-primary {
    filter: saturate(1.05) brightness(1.05);
  }
}
</style>
